import React from 'react';
import './Button.css';

/**
 * SearchButton Component
 * Button specifically styled for search actions
 * 
 * @param {function} onClick - Click handler
 * @param {ReactNode} children - Button content
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 */
const SearchButton = ({ 
  onClick, 
  children = 'Search', 
  disabled = false, 
  className = '' 
}) => {
  return (
    <button
      className={`search-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default SearchButton;

